/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button, message } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView } from 'Components';
import { getSellerList, openAccount } from '../../service/store/staff';
import { accountResetPwd, accountInvalid } from '../../service/account';
import {StaffActions as Actions, StaffStore as Store} from './store';

class StaffList extends Reflux.Component {
  constructor (props) {
    super(props);
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      storeId: parseInt(this.props.params.storeId, 10),
      filterBoxVisible: false,
      rows: [],
      total: 0,
      searchObj: {
        id: parseInt(this.props.params.storeId, 10),
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'staff' && path[3] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    }else{
      Actions.useStoreChange(false);
      Actions.paramChange({});
    }
  }
  componentWillMount () {
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        }
      });
    }
  }

  componentDidMount() {
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  getData () {
    const self = this;
    const {searchObj} = this.state;
    getSellerList(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data});
      }else{
        console.error(res.message);
      }
    });
  }

  goView (url) {
    hashHistory.push(url);
  }

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }

  createAccount(staffId){
    const self = this;
    openAccount({sellerId: staffId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getData();
    })
  }
  invalidAccount(accountId){

    const self = this;
    accountInvalid({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getData();
    })
  }
  resetPwd(accountId){

    const self = this;
    accountResetPwd({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getData();
    })
  }
  goBack () {
    hashHistory.goBack();
  }

  render () {
    const self = this;
    const { rows, total, searchObj, storeId } = this.state;
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          render: (text, record, index) => <a href={`#/staff/${storeId}/${record.id}`}>{text}</a>
        },
        {
          title: '性别',
          dataIndex: 'sexText',
        },
        {
          title: '手机',
          dataIndex: 'mobileText',
        },
        {
          title: '座机',
          dataIndex: 'phoneText',
        },
        {
          title: '邮箱',
          dataIndex: 'emailText',
        },
        {
          title: '岗位',
          dataIndex: 'postText',
        },
        {
          title: '状态',
          dataIndex: 'active',
          render: (text, record, index) => {
            if(text == 0) return '离职';
            if(text == 1) return '在职';
            return '';
          }
        },
        {
          title: '账号',
          dataIndex: 'dmsUser',
          render: (dmsUser, record, index) => dmsUser && dmsUser.account ? dmsUser.account : ''
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index) => record.dmsUser !== null?<span>
            <a onClick={self.invalidAccount.bind(self, record.dmsUser.id)}>禁用账号</a>&nbsp;&nbsp;&nbsp;
            <a onClick={self.resetPwd.bind(self, record.dmsUser.id)}>重置密码</a>
          </span> : <span>
            <a onClick={self.createAccount.bind(self, record.id)}>开通账号</a>
          </span>
        },
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['全部员工']} defaultKey={0}>
        <Button icon="plus" onClick={this.goView.bind(this, `/staff/${this.props.params.storeId}/add/0`)}>新增</Button>
        <Button onClick={this.goBack}>返回</Button>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
;
export default withRouter(StaffList);


// WEBPACK FOOTER //
// ./src/routes/staff/list.js